import React, {useMemo} from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import { BsChevronCompactRight, BsChevronCompactLeft } from "react-icons/all";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import MarketSelector from "../CustomDropdown/MarketSelector";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
  const classes = useStyles();
  const stores = useSelector(state => state.app.stores)
  const activeStore = useSelector(state => state.app.activeStore)
  const activeStoreObj = useSelector((state) => state.app.activeStoreObject);
  const zoneDisplay = useMemo(() => {
    if (activeStoreObj?.tz) {
      moment.tz.setDefault(activeStoreObj.tz);
      return `Timezone: ${activeStoreObj.tz.replace('/',', ').replace('_', ' ')} (UTC${moment().utcOffset()/60})`
    }
    return '';
  }, [activeStoreObj?.tz]);

  const { color, rtlActive, brandText } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color
  });
  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive
    });

  let storeName = ""
  if (brandText === 'Stockroom'){
    for(let i = 0 ; i < stores.length; i++){
      if(stores[i].store_id === activeStore){
        storeName = ` - ${stores[i].name}`;
        break;
      }
    }
  }
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css">
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <Button
                justIcon
                color="white"
                onClick={props.sidebarMinimize}
                className={classes.expandButton}
              >
                <BsChevronCompactRight />
              </Button>
            ) : (
              <Button
                justIcon
                color="white"
                onClick={props.sidebarMinimize}
                className={classes.expandButton}
              >
                <BsChevronCompactLeft />
              </Button>
            )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button href="#" className={classes.title} color="transparent">
            {brandText} {brandText === 'Stockroom' && `${storeName}`}
          </Button>
        </div>
        <MarketSelector setActiveStore/>
        {/*<Hidden smDown implementation="css">*/}
        {/*  <AdminNavbarLinks rtlActive={rtlActive} />*/}
        {/*</Hidden>*/}
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>

      </Toolbar>
      {props.location.pathname === '/hours' && <div className={classes.timezoneBar}>{zoneDisplay}</div>}
    </AppBar>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func
};
